const Expandable = {

    activeExpander: null,
    expanders: [],

    expandItem: function(instance) {
        Object.keys(this.wraps).forEach( index => {
            const wrap = this.wraps[index]
            
            // clear first
            wrap.style.removeProperty('--js-max-height')

            if( ! wrap.contains(instance.trigger) ) {
                wrap.style.setProperty('--js-max-height', `${wrap.offsetHeight}px`)
            }
        })
    },

    collapseItems: function() {
        if( this.activeExpander ) {
            this.setExpanderStates(this.activeExpander, false)
        }
        this.wraps.forEach( wrap => {
            wrap.style.removeProperty('--js-max-height')
        })
    },

    toggle: function(instance) {
        this.collapseItems()

        if( this.activeExpander && this.activeExpander.trigger === instance.trigger ) {
            this.activeExpander = null
            return
        }

        instance.expanded = !instance.expanded

        // Adjust the neighboring element heights first so they don't also expand
        // while this item grows - or, remove the fixed heights if this element is collapsing
        if( instance.expanded ) {
            this.expandItem(instance) 
        }
        
        this.setExpanderStates(instance, instance.expanded)

        if( instance.expanded) {
            this.activeExpander = instance
        }
    },

    setExpanderStates(instance, state) {
        instance.container.classList.toggle('expanded', state)
        instance.trigger.classList.toggle('expanded', state)
        instance.trigger.setAttribute('aria-expanded', state)
        instance.expanded = state
    },

    cacheDom: function() {
        const expanders = document.querySelectorAll('[data-expandable]')
        
        if( !expanders.length ) return
        
        this.root = expanders[0].closest('[data-expandable-root]')
        this.wraps = this.root.querySelectorAll('[data-expandable-wrap]')

        Object.keys(expanders).forEach( index => {
            const container = expanders[index]
            const trigger = container.querySelector('[data-expandable-trigger]')
            const content = container.querySelector('[data-expandable-target]')
            
            if( container && trigger && content ) {
                this.expanders.push({
                    container,
                    trigger,
                    content,
                    expanded: false
                })
            }
        })

        return this.expanders.length > 0
    },

    bind: function() {
        this.toggle = this.toggle.bind(this)

        this.expanders.forEach(instance => {
            const { trigger } = instance

            trigger.addEventListener('click', () => {
                this.toggle(instance)
            })
        })
    },

    init: function() {
        const run = this.cacheDom()
        if( run ) {
            this.bind()
        }
    }
}

export default Expandable